document.addEventListener('dealerLocator:search', e => {
  window.dataLayer.push({
    event: 'dealer_locator_search',
    customerId: window.__VPV.customerId,
    dealer_locator: {
      ...e.detail,
    },
  });
});

document.addEventListener('dealerLocator:filter', e => {
  window.dataLayer.push({
    event: 'dealer_locator_filter',
    dealer_locator: {
      ...e.detail,
    },
  });
});

document.addEventListener('dealerLocator:contact', e => {
  window.dataLayer.push({
    event: 'dealer_locator_contact',
    dealer_locator: {
      contact: {
        ...e.detail,
      },
    },
  });
});

window.addEventListener('vehicleSubmitted', e => {
  const { make, model, year } = e.detail;
  window.dataLayer.push({
    event: 'vehicle_picker_submit',
    vehicle_make: make,
    vehicle_model: model,
    vehicle_year: year,
  });
});

window.addEventListener('variantSelected', e => {
  const { detail } = e;
  if (detail) {
    const currency = Shopify?.currency?.active;
    const productType = detail.product.productType === 'Decked' ? 'Drawers' : detail.product.productType;
    const dataLayerObj = {
      event: 'select_item',
      ecommerce: {
        currency,
        items: [
          {
            item_category: productType,
            item_type: productType,
            item_name: detail.product?.title,
            item_id: detail.id,
            price: detail.priceV2?.amount,
            item_variant: detail.title,
            item_sku: detail.sku,
            quantity: 1,
            currency,
          },
        ],
      },
    };
    window.dataLayer.push(dataLayerObj);
  }
});

document.addEventListener('variant:add', e => {
  const { items } = e.detail;
  const item = items[0];
  if (item) {
    const currency = Shopify?.currency?.active;
    const productType = item.product_type === 'Decked' ? 'Drawers' : item.product_type;
    const dataLayerObj = {
      event: 'custom_add_to_cart',
      ecommerce: {
        currency,
        items: [
          {
            item_category: productType,
            item_type: productType,
            item_name: item.product_title,
            item_photo: item.image,
            item_id: item.variant_id,
            price: (item.price / 100).toFixed(2),
            item_brand: item.vendor,
            item_variant: item.variant_title,
            item_sku: item.sku,
            quantity: 1,
          },
        ],
      },
    };
    window.dataLayer.push(dataLayerObj);
  }
});

const cartDrawerEl = document.getElementById('cart-drawer');
if(cartDrawerEl){
  cartDrawerEl.addEventListener('toggle', e => {
    const event = e.target.open ? 'mini_cart_open' : 'mini_cart_close';
    window.dataLayer.push({
      event,
    });
  });
}
